var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.08789C4.965 2.08789 1.6875 5.36539 1.6875 9.40039C1.6875 13.4354 4.965 16.7129 9 16.7129C13.035 16.7129 16.3125 13.4354 16.3125 9.40039C16.3125 5.36539 13.035 2.08789 9 2.08789ZM9 15.5879C5.5875 15.5879 2.8125 12.8129 2.8125 9.40039C2.8125 5.98789 5.5875 3.21289 9 3.21289C12.4125 3.21289 15.1875 5.98789 15.1875 9.40039C15.1875 12.8129 12.4125 15.5879 9 15.5879Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.83789H9.5625V5.65039C9.5625 5.34289 9.3075 5.08789 9 5.08789C8.6925 5.08789 8.4375 5.34289 8.4375 5.65039V9.40039C8.4375 9.70789 8.6925 9.96289 9 9.96289H12.75C13.0575 9.96289 13.3125 9.70789 13.3125 9.40039C13.3125 9.09289 13.0575 8.83789 12.75 8.83789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7147a152045791c6445131da2754b968.svg";
export { ForwardRef as ReactComponent };